import React from 'react'

import SVGIcon from '../../svg-icon/svg-icon'
import ContextMenuItem from '../context-menu-item/context-menu-item'

import EditIcon from 'assets/images/icons/pencil.svg'
import lang from '@/lang'

const ContextMenuEditItem = (props) => {
  const { onItemClick } = props

  const icon = <SVGIcon width="13px" height="13px" svg={ EditIcon } fill='#757b8a' />

  return (
    <ContextMenuItem
      label={lang.editButtonLabel}
      icon={icon}
      onItemClick={onItemClick} />
  )
}

export default ContextMenuEditItem
